import axios from "axios";
import axiosRetry from "axios-retry";

const dev = 'http://192.168.0.106:8082'
const prod = 'https://jaina.spapi.in'

const api = axios.create({
    baseURL: prod,
    timeout: 15000,
    headers: {
        'Content-Type' : 'application/json',
    }
})

// Retry configuration
axiosRetry(api, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: error =>
    axiosRetry.isNetworkOrIdempotentRequestError(error),
});

// Add a request interceptor to include the token and compid in the headers
api.interceptors.request.use(
    async (config) => {
      try {
        const token = localStorage.getItem("JainaAccessToken");
  
        if (token) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }

      } catch (error) {
        console.error("Error retrieving token or setting headers:", error);
      }
  
      return config;
    },
    (error) => {
      console.log("Axios error", error);
      return Promise.reject(error);
    }
  );

  // Response interceptor — handle unauthorized

// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (
//       error.response &&
//       (error.response.status === 401 || error.response.status === 403)
//     ) {
//       // Remove token
//       localStorage.removeItem("JainaAccessToken");
//       // Redirect to login (assuming you're using window.location or react-router
//       window.location.href = "/";
//     }
//     return Promise.reject(error);
//   }
// );



export default api;